import { render, staticRenderFns } from "./ModalPaymentMethod.vue?vue&type=template&id=1485f437&"
import script from "./ModalPaymentMethod.vue?vue&type=script&lang=js&"
export * from "./ModalPaymentMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports